const user = (state = {}, action: any) => {
	switch(action.type) {
		case 'SET_REQUEST_PLAN':
			return action.payload;
		default: 
			return state;
	}
}

export default user;